
    // workaround for:
    // https://github.com/vitejs/vite/issues/1973
    window.process = window.process ? window.process : { cwd: () => "" };
  